import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  Validators,
} from "@angular/forms";

@Component({
  selector: "app-love-it-input",
  templateUrl: "./love-it-input.component.html",
  styleUrls: ["./love-it-input.component.scss"],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LoveItInputComponent),
      multi: true,
    },
  ],
})
export class LoveItInputComponent implements ControlValueAccessor, OnChanges {
  @Input() formControl: FormControl;
  @Input() submitted: boolean;
  @Input() label: string;
  @Input() suffix: string;
  @Input() type: string;
  @Input() placeholder: string;
  @Input() decimalLimit: number = -1;
  @Input() disabled: boolean;
  @Input() value: string = "";

  @Output() onTextEdited: EventEmitter<string> = new EventEmitter<string>();
  @Output() ionBlur: EventEmitter<string> = new EventEmitter<string>();
  @Output() ionFocus: EventEmitter<string> = new EventEmitter<string>();

  onChange: (value: string) => void = () => {};
  onTouched: () => void = () => {};

  ngOnChanges(changes: SimpleChanges) {
    if (changes["disabled"] && this.formControl) {
      if (this.disabled) {
        this.formControl.disable({ emitEvent: false });
      } else {
        this.formControl.enable({ emitEvent: false });
      }
    }
  }

  constructor() {}

  writeValue(value: string): void {
    this.value = value ?? "";
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onIonBlur(event) {
    const value = event?.detail?.value ?? this.formControl.value ?? "";
    this.ionBlur.emit(value);
    this.limitDecimals(event);
    this.onTouched();
  }

  onIonFocus(event) {
    const value = event?.detail?.value ?? this.formControl.value ?? "";
    this.ionFocus.emit(value);
    this.limitDecimals(event);
  }

  onInputChange(event) {
    const value = event?.detail?.value ?? this.formControl.value ?? "";
    this.onTextEdited.emit(value);
    this.limitDecimals(event);
    this.onChange(this.formControl.value ?? "");
  }

  onIonInput(event) {
    this.limitDecimals(event);
    this.onChange(this.formControl.value ?? "");
  }

  limitDecimals(event) {
    if (this.decimalLimit >= 0) {
      let value = event.target.value;

      value = value.replace(/[^0-9.]/g, "");

      const parts = value.split(".");

      if (parts.length > 2) {
        value = parts[0] + "." + parts[1];
      }

      if (this.decimalLimit === 0) {
        value = parts[0];
      } else if (parts[1]?.length > this.decimalLimit) {
        parts[1] = parts[1].substring(0, this.decimalLimit);
        value = parts.join(".");
      }

      this.formControl.setValue(value, { emitEvent: false });
    }
  }

  protected readonly Validators = Validators;
}
